import { API_BASE_URL, API_HAS_ALL_CLIENT_ORG_LICENSE_STATUS_PATH } from "../../../consts";
import axios from "axios";
import refreshAccessToken from './../refreshAccessToken';


interface getRightResponse {
    has_all_rights: boolean;
}

async function executeHasAllClientOrgLicenseStatusWithToken(accessToken: string | null, scope: string, key: string, levels: Iterable<string>): Promise<getRightResponse> {
    return axios
        .post(
            API_BASE_URL + API_HAS_ALL_CLIENT_ORG_LICENSE_STATUS_PATH,
            {
                scope: scope,
                key: key,
                levels: levels
            },
            {
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
                withCredentials: true,
            }
        )
        .then(response => {
            if (response.status === 200) {
                return Promise.resolve(response.data);
            }
        })
        .catch(error => {
            if (error.response && error.response.status === 400) {
                console.log(`Bad request with scope: ${scope}, key: ${key}, levels: ${levels}`);
            } else if (error.response && error.response.status === 404) {
                console.log(`Bad request with scope: ${scope}, key: ${key}, levels: ${levels}`);
            } else {
                console.error('Error during confirming permission', error);
            }
            return Promise.reject(error);
        });
}


export default async function autoRefreshedExecuteHasAllClientOrgLicenseStatusWithToken(accessToken: string | null, scope: string, key: string, levels: Iterable<string>): Promise<getRightResponse> {

    return executeHasAllClientOrgLicenseStatusWithToken(accessToken, scope, key, levels)
        .catch(error => {
            if (error.response.status == 401) {
                return refreshAccessToken().then(refreshedAccessToken => {
                    if (refreshedAccessToken) {
                        console.log("refreshed");
                        return executeHasAllClientOrgLicenseStatusWithToken(refreshedAccessToken, scope, key, levels);
                    } else {
                        throw error;
                    }
                });
            }
            throw error;
        });
}
